import { FETCH_CATALOGS, SELECT_CATALOG, GET_DEFAULT_CATALOG } from '@/redux/actions/catalogs.actions'

const initialState = {
	loading: false,
	selected: null,
	list: [],
	defaultCatalog: {}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case FETCH_CATALOGS.REQUEST:
			return true
		case FETCH_CATALOGS.SUCCESS:
		case FETCH_CATALOGS.FAILURE:
			return false
		default:
			return state
	}
}

const list = (state = initialState.list, action) => {
	switch (action.type) {
		case FETCH_CATALOGS.SUCCESS:
			return action.payload
		case FETCH_CATALOGS.FAILURE:
		case FETCH_CATALOGS.REQUEST:
			return []
		default:
			return state
	}
}

const selected = (state = initialState.selected, action) => {
	switch (action.type) {
		case SELECT_CATALOG:
			return action.payload.catalogId
		default:
			return state
	}
}

const defaultCatalog = (state = initialState.defaultCatalog, action) => {
	switch (action.type) {
		case GET_DEFAULT_CATALOG.SUCCESS:
			return action.payload
		case GET_DEFAULT_CATALOG.FAILURE:
			return 16
		default:
			return state
	}
}

export default {
	name: 'catalogs',
	reducers: {
		loading,
		list,
		selected,
		defaultCatalog
	}
}
